import { useQuery } from "@tanstack/react-query";
import { fetchKeywords, KeywordsParams } from "PFCore/services/keywords";
import { Collection, Keyword } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import { keywordsKeys } from "./query_keys";

export const useKeywords = <TData = Collection<Keyword[]>>(
  params: KeywordsParams,
  options: QueryOptions<Collection<Keyword[]>, any, TData> = {}
) =>
  useQuery({
    queryKey: keywordsKeys.all(params),
    queryFn: () => fetchKeywords(params) as Promise<Collection<Keyword[]>>,
    ...options
  });
